<template>
<div class="popup" v-show="optionDialogShow" v-cloak>
    <div class="content" id="taskTransferOptions">
        <div class="title">
            {{$t('language.common.options')}}
            <div class="icon white-close dialog-close" @click="optionClose()"></div>
        </div>
        <div class="transfer-options-body">
            <div class="transfer-options-cont">
                <el-tabs v-model=activeName>
                    <el-tab-pane :label="$t('language.emailTransfer.migrationSetting')" name="first">
                        <tab1 ref="tab1" ></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.emailTransfer.notification')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                    <el-tab-pane name="third">
                        <span slot="label" class="transfer-vip">
                            <span>{{$t('language.emailTransfer.watermark')}}</span>
                            <div class="icon-util vip filter-position"></div>
                        </span>
                        <tab3 ref="tab3"></tab3>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="transfer-options-footer">
                <button style="float:right;" @click="optionSubmit()">{{$t('language.common.save')}}</button>
                <button class="white-button" style="float:right;margin-right: 10px;" @click="optionClose()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/transfer_options.css'
import tab1 from "@/components/common/tabs/tabs_transfer_options/tab_email_transfer";
import tab2 from "@/components/common/tabs/tabs_transfer_options/tab_email";
import tab3 from "@/components/common/tabs/tabs_transfer_options/tab_email_watermark";
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    components: {
        tab1,
        tab2,
        tab3,
    },
    data: function () {
        return {
            activeName: "first",
            optionDialogShow: false,
            tabs: [{
                name: this.$t('language.cloudTransfer.transfer')
            }, {
                name: this.$t('language.popup.email')
            }, {
                name: this.$t('language.popup.filter')
            }],
            indexCurrent: 0,
            tabBarClass: '',
            options: {
                replace: 4,
                isRemove: 0,
                isKeep: 0,
                isChar: 1,
                attachment: true,
                conversationQuoted: true,
                onlyLastMail: false,
                delWatermark: false,
            },
            item: '',
            itemIndex: -1
        };
    },
    methods: {
        caseOption(number) {
            let value;
            switch (number) {
                case 2:
                    value = this.$t('language.popup.skipFile');
                    break;
                case 3:
                    value = this.$t('language.popup.sourceNewer');
                    break;
                case 1:
                    value = this.$t('language.popup.diffSize');
                    break;
                case 5:
                    value = this.$t('language.popup.sourceAll');
                    break;
                case 4:
                    value = this.$t('language.popup.overWriteSourceNewer');
                    break;
                case 0:
                    value = this.$t('language.popup.rename');
                    break;
            }
            return value;
        },
        optionSubmit() {
            //保存用户所选择的数据并触发父组件的事件
            delete this.options.matched;
            delete this.options.pattern;
            let user = commonUtils.getUser();
            this.options.attachment = this.$refs.tab1.isSaveAtt;
            this.options.conversationQuoted = this.$refs.tab1.isConver;
            this.options.onlyLastMail = this.$refs.tab1.isSaveOnly;
            this.options.isChar = this.$refs.tab1.isChar;
            this.options.replace = this.$refs.tab1.replace;
            this.options.delWatermark = this.$refs.tab3.delWatermark;
            //用户选择了vip选项
            if(!user.vip&&this.$refs.tab3.delWatermark) {
                var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_filter');
                upgradeNewDialog.curItem = 'filter';
                upgradeNewDialog.isShow = true;
                return false;
            }
            //当用户勾选了邮箱但没有填邮箱
            if (!this.$refs.tab2.email && this.$refs.tab2.sendShow) {
                this.indexCurrent = 1;
                this.activeName = 'second';
                this.$refs.tab2.shakeBox = "email-shake";
                setTimeout(() => {
                    this.$refs.tab2.shakeBox = "box-shakeOrigin";
                }, 200);
            } else {
                if (this.$refs.tab2.email) {
                    if (!commonstate.emailpattern.test(this.$refs.tab2.email)) {
                        this.activeName = 'second';
                        this.$toast({
                            text: this.$t('language.login.enterCorrectEmai'),
                            type: 'fail',
                            idValue: "taskTransferOptions"
                        });
                        return false;
                    }
                    this.options.email = this.$refs.tab2.email;
                } else {
                    delete this.options.email;
                }
            }
            if (!this.item.options.email && this.options.email &&this.item.sources&& this.item.sources.length >= 10 && this.item.type == 1) {
                this.$parent.$refs.noticeDialog.noticeShow = true;
                this.$parent.$refs.noticeDialog.transferFlag = 3;
                this.$parent.$refs.noticeDialog.transferFrom = 1;
            } else {
                this.optionSubmitDetail();
            }
        },
        optionSubmitDetail() {
            this.updateOptionRequest();

        },
        updateOptionRequest() {
            let that = this;
            var updateData;
            let item = Object.assign({}, this.item);
            let options = this.options;
            let getData;
            if (this.item.isMultiTask) {
                let gd = this.item.id;
                updateData = new taskTransferUtils.updateGdTaskData(gd, commonUtils.getUser().id, this.item.type, this.item.name, options, null);
            } else {
                let id = this.item.id;
                updateData = new taskTransferUtils.updateIdTaskData(id, commonUtils.getUser().id, this.item.type, this.item.name, options, null);
            }
            that.optionDialogShow = false;
            that.$parent.$forceUpdate();
            this.Utils.doTasksRequest("update", updateData).then(result => {
                if (result.status == 200) {
                    if (item.groupId) {
                        getData = {
                            ud: commonUtils.getUser().id,
                            type: item.type,
                            gd: item.groupId
                        }
                    } else {
                        getData = {
                            ud: commonUtils.getUser().id,
                            type: item.type,
                            id: item.id,
                        }
                    }
                    that.Utils.doTasksRequest("get", getData).then(res => {
                        let data = that.$parent.taskListOriginal[that.itemIndex];
                        data.options = res.tasks[0].options;
                        that.$parent.$forceUpdate();
                    });
                } else {
                    this.$toast({
                        text: this.$t('language.exception.' + result.reason),
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                }
            });
        },
        optionClose() {
            //还原用户之前选择的数据
            this.optionDialogShow = false;
        }
    }
};
</script>

<style>
#taskTransferOptions #tab-2,
#taskTransferOptions #tab-first,
#taskTransferOptions #tab-second {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
}

#taskTransferOptions #tab-third {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    top: 5Px !important;
}

#tab-second {
    margin-left: 0 !important;
}

.is-top {
    margin: 0 !important;
}

#taskTransferOptions .el-tabs__content {
    height: 250px;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_email_transfer_options_popup.vue